import { appConfig } from '../config/appConfig';
import { setRuntimeConfig } from './runtimeConfig';

const CONFIG_URL =
  (import.meta.env.VITE_CONFIG_URL as string | undefined) ||
  (window.location.hostname === 'localhost' ? '/config.json' : '');

/**
 * Fetches the runtime auth config from the blob URL (or local /config.json
 * in dev). Stores the result in the runtime config store; falls back silently
 * to the static appConfig values if the fetch fails. Must complete before
 * the app's AuthService is constructed.
 */
export async function initRuntimeConfig(): Promise<void> {
  if (!CONFIG_URL) return;
  try {
    const res = await fetch(CONFIG_URL);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const config = (await res.json()) as {
      authAuthority?: string;
      authClientId?: string;
      authClientSecret?: string;
    };
    setRuntimeConfig(config);
  } catch {
    // fall back to static appConfig values
  }
}

export { appConfig };
